export const QuestStatus = {
  Active: 0,
  Completed: 1,
  Failed: 2,
  Hidden: -1
}
